module.exports = __webpack_public_path__ + "img/day_logo(1).7e122e7.png";